import { BiSearch } from 'react-icons/bi';
import { IoMdMail } from 'react-icons/io';
import { MdAttachMoney, MdCheckCircleOutline, MdChevronLeft, MdChevronRight, MdDownload, MdWatchLater } from 'react-icons/md';
import { RiPrinterFill } from 'react-icons/ri';
import { FiEdit, FiTrash2, FiXCircle } from "react-icons/fi";


const CustomButton = ({ onClick, text, type, buttonType, className: customClassName, disabled, showIcon = true }) => {
    const buttonTypes = {
        cancel: {
            icon: FiXCircle,
            className: 'bg-custom_red',
        },
        save: {
            icon: MdCheckCircleOutline,
            className: 'bg-custom_green',
        },
        edit: {
            icon: FiEdit,
            className: 'bg-custom_blue',
        },
        delete: {
            icon: FiTrash2,
            className: 'bg-custom_red'
        },
        confirm: {
            icon: MdCheckCircleOutline,
            className: 'bg-custom_blue',
        },
        backSmall: {
            icon: MdChevronLeft,
            className: 'bg-custom_blue hover:bg-blue-600 '
        },
        forwardSmall: {
            icon: MdChevronRight,
            className: 'bg-custom_blue hover:bg-blue-600 '
        },
        confirmLater: {
            icon: MdWatchLater,
            className: 'bg-custom_yellow',
        },
        download: {
            icon: MdDownload,
            className: 'bg-custom_blue',
        },
        editCredits: {
            icon: MdAttachMoney,
            className: 'bg-custom_blue',
        },
        print: {
            icon: RiPrinterFill,
            className: 'bg-custom_blue',
        },
        sendNotification: {
            icon: IoMdMail,
            className: 'bg-custom_blue',
        },
        search: {
            icon: BiSearch,
            className: 'bg-custom_green',
        },
        neutral: {
            icon: '',
            className: 'bg-custom_gray_font',
        }
    };

    const { icon: Icon, className: defaultClassName } = buttonTypes[buttonType] || {};

    return (
        <button
            className={`flex items-center justify-center h-full text-white font-medium p-2 rounded-lg disabled:opacity-50 ${defaultClassName} ${customClassName}`}
            onClick={onClick}
            disabled={disabled}
            type={type}
        >
            {showIcon && Icon && <Icon className="text-white scale-125 mx-2" />}
            <span className="flex items-center gap-2 text-white font-medium leading-tight whitespace-nowrap">
                {text}
            </span>
        </button>
    );
};

export default CustomButton;
